import moment from "moment"

function renderSelectedItem(selectedMode: any, selectedItem: any) {
  let displayString = ""
  if (selectedMode === "Day") {
    displayString = moment(selectedItem).format("DD MMMM, dddd")
  } else if (selectedMode === "Week") {
    const startOfWeek = moment(selectedItem).clone().weekday(0).format("DD")
    const endOfWeek = moment(selectedItem).clone().weekday(6).format("DD")
    const mmyyyy = moment(selectedItem).format("MMMM, yyyy")
    displayString = `${startOfWeek}-${endOfWeek} ${mmyyyy}`
  } else if (selectedMode === "Month") {
    displayString = moment(selectedItem).format("MMMM, yyyy")
  }
  return displayString
}

function checkCurrentWeekDay(eachWeekDay: any) {
  return moment().format("dddd")?.toLowerCase() === eachWeekDay?.toLowerCase()
}

function checkIfSameMonth(date: any, selectedDate: any) {
  const startMonth = moment(selectedDate).startOf("month").format("YYYY-MM-DD")
  const endOfMonth = moment(selectedDate).endOf("month").format("YYYY-MM-DD")
  return (
    moment(date).isBetween(startMonth, endOfMonth) ||
    moment(date).isSame(startMonth) ||
    moment(date).isSame(endOfMonth)
  )
}

function getCurrentWeek(date: any) {
  var weekStart = moment(date).clone().startOf("week")

  var days = []

  for (var i = 0; i <= 6; i++) {
    const totalDate = moment(weekStart).add(i, "days").format("YYYY-MM-DD")
    const date = moment(weekStart).add(i, "days").format("DD")
    const day = moment(weekStart).add(i, "days").format("dddd")
    days.push({
      totalDate,
      date,
      day,
    })
  }
  return days
}

function getCurrentMonth(date: any) {
  const startWeek = moment(date)?.startOf("month")?.isoWeek()
  const endWeek = moment(date)?.endOf("month")?.isoWeek()
  let calendar: Array<any> = []
  for (var week = startWeek; week <= endWeek; week++) {
    let year = moment(date)?.isoWeekYear() // Get the year for the current week
    if (week === 1 && moment(date)?.month() === 11) {
      year++
    }
    Array(7)
      ?.fill(0)
      ?.map((n, i) => {
        const day = moment()
          ?.isoWeekYear(year)
          ?.isoWeek(week)
          ?.startOf("week")
          ?.clone()
          ?.add(n + i, "day")
        calendar.push(day)
      })
  }
  return calendar
}

function createTimeSlots(openTime: any, closeTime: any, slotInterval: any) {
  let startTime = moment(openTime, "HH:mm:ss")

  //Format the end time and the next day to it
  let endTime = moment(closeTime, "HH:mm:ss")

  //Times
  let allTimes = []

  //Loop over the times - only pushes time with given minutes interval

  while (startTime < endTime) {
    //Push times
    allTimes.push(startTime.format("hh:mm a"))
    //Add interval of given minutes
    startTime.add(slotInterval, "minutes")
  }
  return allTimes
}

function fetchStartAndEndDate(selectedItem: any, selectedMode: any) {
  let startDate = ""
  let endDate = ""

  if (selectedMode === "Day") {
    startDate = moment(selectedItem).format("YYYY-MM-DD")
    endDate = moment(selectedItem).format("YYYY-MM-DD")
  } else if (selectedMode === "Week") {
    startDate = moment(selectedItem)
      ?.clone()
      ?.startOf("week")
      ?.format("YYYY-MM-DD")
    endDate = moment(selectedItem)?.clone()?.endOf("week")?.format("YYYY-MM-DD")
  } else if (selectedMode === "Month") {
    const startOfMonth = moment(selectedItem)?.startOf("month")
    const endOfMonth = moment(selectedItem)?.endOf("month")

    const startWeek = startOfMonth?.isoWeek()
    const endWeek = endOfMonth?.isoWeek()

    const disp1 = startOfMonth?.clone()?.startOf("isoWeek")
    let disp2 = endOfMonth?.clone()?.endOf("isoWeek")

    if (endWeek === 1 && moment(selectedItem)?.month() === 11) {
      disp2 = moment(selectedItem)
        ?.endOf("year")
        ?.startOf("isoWeek")
        ?.add(6, "day")
    }

    startDate = moment(disp1).format("YYYY-MM-DD")
    endDate = moment(disp2).format("YYYY-MM-DD")
  }

  return { startDate: startDate, endDate: endDate }
}

function fetchCountData(appointments: any, date: any, type: string) {
  if (type === "OPD") {
    const data1 = appointments?.filter(
      (each: any) =>
        each?.appointmentType === "OPD" &&
        ((!each?.isRescheduled && !each?.isSpecialRequest) ||
          (each?.isRescheduled && each?.status !== "CANCELLED"))
    )
    return data1?.length
  } else if (type === "IPD") {
    const data2 = appointments?.filter(
      (each: any) =>
        each?.appointmentType === "IPD" &&
        (!each?.isRescheduled ||
          (each?.isRescheduled && each?.status !== "CANCELLED")) &&
        each?.allottedBed?.slots?.length > 0
    )
    return data2?.length
  }
  // const data = appointments?.filter(
  //   (each: any) =>
  //     each?.appointmentType === type &&
  //     moment(each?.scheduleDate).isSame(moment(date))
  // )
  // return data?.length
}

function getPatientAppointmentType(patientAppointmentType: any) {
  return patientAppointmentType === "FOLLOW_UP"
    ? "FOLLOW UP"
    : patientAppointmentType === "WALK_IN"
      ? "WALK IN"
      : "NEW"
}

function getAppointmentStatus(status: any) {
  return status === "BOOKED"
    ? "confirmed"
    : status === "ARRIVED"
      ? "arrived"
      : status === "WAITING_FOR_APPROVAL"
        ? "pending"
        : status === "CANCELLED"
          ? "cancelled"
          : status === "ONHOLD"
            ? "on hold"
            : status === "ONGOING"
              ? "ongoing"
              : status === "RESCHEDULED"
                ? "rescheduled"
                : status === "COMPLETED"
                  ? "completed"
                  : status === "REVIEW"
                    ? "review"
                    : status === "NO_SHOW"
                      ? "no show"
                      : ""
}

const AppointmentCalendarUtils = {
  renderSelectedItem,
  checkCurrentWeekDay,
  getCurrentWeek,
  getCurrentMonth,
  checkIfSameMonth,
  createTimeSlots,
  fetchStartAndEndDate,
  fetchCountData,
  getPatientAppointmentType,
  getAppointmentStatus,
}
export default AppointmentCalendarUtils
